module.exports = __webpack_public_path__ + "fonts/DINPro-CondMedium.bf27039e.otf";